import React from 'react'
import PropTypes from 'prop-types'
import TooltipComponent from '../utils/TooltipComponent'
import IconComponent from './IconComponent'
import ButtonComponent from './ButtonComponent'

const EditButtonComponent = ({ onClick, children, disabled }) => {
  return (
    <TooltipComponent content="Edit" id="edit-tooltip" placement="top">
      <ButtonComponent type="button" color="warning mb-1" onClick={onClick} disabled={disabled}>
        <IconComponent icon="Edit" height="18"  />
        &nbsp;{children}
      </ButtonComponent>
    </TooltipComponent>
  )
}

EditButtonComponent.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.node,
}

export default EditButtonComponent
